import {
  VALIDATE_JIRA_TICKET,
  VALIDATE_JIRA_TICKET_SUCCESS,
  VALIDATE_JIRA_TICKET_ERROR,
  VALIDATE_JIRA_TICKET_EMPTY,
} from '../../actions.js';

const initialState = { data: null, loading: false, error: null };

const ValidateJiraTicket = (state = initialState, action) => {
  switch (action.type) {
    case VALIDATE_JIRA_TICKET:
      return { ...state, loading: true, data: null, error: null };
    case VALIDATE_JIRA_TICKET_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case VALIDATE_JIRA_TICKET_ERROR:
      return { ...state, loading: false, error: action.payload };
    case VALIDATE_JIRA_TICKET_EMPTY:
      return { ...initialState };
    default:
      return state;
  }
};

export default ValidateJiraTicket;
